import inputStyles from '../UI/EditableCell.module.css';

interface CommentCellProps {
  value: string;
  isEditing: boolean;
  draft: string;
  onDraftChange: (value: string) => void;
  onSave: () => void;
  onCancel: () => void;
}

export const CommentCell = ({
  value,
  isEditing,
  draft,
  onDraftChange,
  onSave,
  onCancel
}: CommentCellProps) => {
  if (!isEditing) return <span>{value}</span>;

  return (
    <input
      className={inputStyles.input}
      type="text"
      value={draft}
      onChange={(e) => onDraftChange(e.target.value)}
      onKeyDown={(e) => {
        if (e.key === 'Enter') onSave();
        else if (e.key === 'Escape') onCancel();
      }}
    />
  );
};
